<template>
    <div>

        <v-card>
            <v-container class="print-button-container">
                <v-row>
                    <v-col cols="12">
                        <v-btn
                            block
                            color="info"
                            :loading="loadingGraphs || loadingCounts"
                            @click="print"
                        >
                            Print Dashboard
                        </v-btn>
                    </v-col>
                </v-row>
            </v-container>
        </v-card>

        <v-card>
            <v-container>
                <v-row v-if="loadingGraphs || loadGraphsError" class="notPrinted">
                    <v-col cols="12">
                        <v-progress-linear :indeterminate="true"></v-progress-linear>
                    </v-col>
                </v-row>

                <v-row  v-else class="notPrinted">

                    <v-col cols="12" lg="6">
                        <v-container>
                            <v-row  class="graphs-container">
                                <v-col cols="12" class="graph-container text-center">
                                    <h2>Alive Specimens by Species</h2>
                                </v-col>
                                <v-col cols="12" md="6" offset-md="3" class="graph-container text-center" v-if="aliveSpecimensBySpeciesData.labels.length <= 0">
                                    <v-alert
                                        :value="true"
                                        color="info"
                                        icon="info"
                                        outlined
                                    >
                                        No specimen data for the selected period
                                    </v-alert>
                                </v-col>
                                <v-col cols="12" class="graph-container" v-if="aliveSpecimensBySpeciesData.labels.length > 0">
                                    <DashboardBarGraph :height="graphHeight" :data="aliveSpecimensBySpeciesData" :options="aliveSpecimensBySpeciesGraphOptions" ref="refAliveSpecimensBySpeciesGraph"></DashboardBarGraph>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-col>

                    <v-col cols="12" lg="6">
                        <v-container>
                            <v-row  class="graphs-container">
                                <v-col cols="12" class="graph-container text-center">
                                    <h2>Alive Specimens by Room</h2>
                                </v-col>
                                <v-col cols="12" md="6" offset-md="3" class="graph-container text-center" v-if="aliveSpecimensByRoomData.labels.length <= 0">
                                    <v-alert
                                        :value="true"
                                        color="info"
                                        icon="info"
                                        outlined
                                    >
                                        No specimen data for the selected period
                                    </v-alert>
                                </v-col>
                                <v-col cols="12" class="graph-container" v-if="aliveSpecimensByRoomData.labels.length > 0">
                                    <DashboardBarGraph :height="graphHeight" :data="aliveSpecimensByRoomData" :options="aliveSpecimensByRoomGraphOptions" ref="refAliveSpecimensByRoomGraph"></DashboardBarGraph>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-col>

                    <v-col cols="12" lg="6">
                        <v-container>
                            <v-row  class="graphs-container">
                                <v-col cols="12" class="graph-container text-center">
                                    <h2>Alive Specimens by Geographical Source</h2>
                                </v-col>
                                <v-col cols="12" md="6" offset-md="3" class="graph-container text-center" v-if="aliveSpecimensByGeographicalLocationData.labels.length <= 0">
                                    <v-alert
                                        :value="true"
                                        color="info"
                                        icon="info"
                                        outlined
                                    >
                                        No specimen data for the selected period
                                    </v-alert>
                                </v-col>
                                <v-col cols="12" class="graph-container" v-if="aliveSpecimensByGeographicalLocationData.labels.length > 0">
                                    <DashboardPieGraph :height="graphHeight" :data="aliveSpecimensByGeographicalLocationData" :options="aliveSpecimensByGeographicalLocationGraphOptions" ref="refAliveSpecimensByGeographicalLocationGraph"></DashboardPieGraph>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-col>

                    <v-col cols="12" lg="6">
                        <v-container>
                            <v-row  class="graphs-container">
                                
                                <v-col cols="12" class="graph-container text-center">
                                    <h2>Available Species Batch Pools</h2>
                                </v-col>
                                
                                <v-col cols="12" class="graph-container" v-if="rawData.availableSpeciesBatchPoolWeights && rawData.availableSpeciesBatchPoolWeights.length > 0">
                                    <AvailableSpeciesBatchPoolsTable :data="rawData.availableSpeciesBatchPoolWeights"></AvailableSpeciesBatchPoolsTable>
                                </v-col>
                                <v-col cols="12" md="6" offset-md="3" class="graph-container text-center" v-else>
                                    <v-alert
                                        :value="true"
                                        color="info"
                                        icon="info"
                                        outlined
                                    >
                                        No available species batch pools
                                    </v-alert>
                                </v-col>

                            </v-row>
                        </v-container>
                    </v-col>

                </v-row>
            </v-container>
        </v-card>

        <v-card v-if="printing">
            <v-container>
                <v-row  class="graphs-container">
                    <v-col cols="12" class="graph-container text-center">
                        <h2>Alive Specimens by Species</h2>
                    </v-col>
                    <v-col cols="12" md="6" offset-md="3" class="graph-container text-center" v-if="aliveSpecimensBySpeciesData.labels.length <= 0">
                        <v-alert
                            :value="true"
                            color="info"
                            icon="info"
                            outlined
                        >
                            No specimens data for the selected period
                        </v-alert>
                    </v-col>
                    <v-col cols="12" class="graph-container" v-else>
                        <PrintGraph :src="aliveSpecimensBySpeciesImg"></PrintGraph>
                    </v-col>
                </v-row>
                <v-row  class="graphs-container">
                    <v-col cols="12" class="graph-container text-center">
                        <h2>Alive Specimens by Rooms</h2>
                    </v-col>
                    <v-col cols="12" md="6" offset-md="3" class="graph-container text-center" v-if="aliveSpecimensByRoomData.labels.length <= 0">
                        <v-alert
                            :value="true"
                            color="info"
                            icon="info"
                            outlined
                        >
                            No room data for the selected period
                        </v-alert>
                    </v-col>
                    <v-col cols="12" class="graph-container" v-else>
                        <PrintGraph :src="aliveSpecimensByRoomImg"></PrintGraph>
                    </v-col>
                </v-row>
                <v-row  class="graphs-container">
                    <v-col cols="12" class="graph-container text-center">
                        <h2>Alive Specimens by Geographical Location</h2>
                    </v-col>
                    <v-col cols="12" md="6" offset-md="3" class="graph-container text-center" v-if="aliveSpecimensByGeographicalLocationData.labels.length <= 0">
                        <v-alert
                            :value="true"
                            color="info"
                            icon="info"
                            outlined
                        >
                            No room data for the selected period
                        </v-alert>
                    </v-col>
                    <v-col cols="12" class="graph-container" v-else>
                        <PrintGraph :src="aliveSpecimensByGeographicalLocationImg"></PrintGraph>
                    </v-col>
                </v-row>

            </v-container>
        </v-card>

        <v-card>
            <v-container>
                <v-row  v-if="!printing">
                    <v-col cols="12" sm="6" offset-sm="3">
                        <v-select
                            :disabled="loadingGraphs"
                            :items="rangeOptions"
                            item-text="text"
                            item-value="value"
                            v-model="selectedRangeOption"
                            label="Period"
                        ></v-select>
                    </v-col>
                </v-row>
                <v-row  class="dialog-action-buttons">
                    <v-col cols="12" class="text-center dates-label">
                        <h1>{{rangeDates.start.format(constants.DATE_FORMAT_NO_TIME)}} &mdash; {{rangeDates.end.format(constants.DATE_FORMAT_NO_TIME)}}</h1>
                    </v-col>
                </v-row>
            </v-container>
        </v-card>

        <v-card>
            <v-container>
                <v-row v-if="loadingCounts" class="notPrinted">
                    <v-col cols="12">
                        <v-progress-linear :indeterminate="true"></v-progress-linear>
                    </v-col>
                </v-row>

                <v-row v-else-if="!loadingCounts && loadCountsError" class="notPrinted">
                    <v-col cols="12">
                        <v-alert outlined :value="true" color="error" icon="error">
                            {{loadCountsError}}
                        </v-alert>
                    </v-col>
                </v-row>

                <v-row v-else  class="dialog-action-buttons">
                    <v-col cols="12" class="text-center">
                        <h2>{{rangeDates.start.format(constants.DATE_FORMAT_NO_TIME)}} &mdash; {{rangeDates.end.format(constants.DATE_FORMAT_NO_TIME)}} Stats</h2>
                    </v-col>
                    <v-col cols="12" sm="6" class="text-center">
                        <v-alert
                            :value="true"
                            color="warning"
                            icon="info"
                            outlined
                        >
                            {{controlledOccurrenceCount}} Controlled Occurrences
                        </v-alert>
                    </v-col>
                    <v-col cols="12" sm="6" class="text-center">
                        <v-alert
                            :value="true"
                            color="error"
                            icon="info"
                            outlined
                        >
                            {{dangerousOccurrenceCount}} Dangerous Occurrences
                        </v-alert>
                    </v-col>
                    <v-col cols="12" md="6" class="text-center">
                        <v-alert
                            :value="true"
                            color="info"
                            icon="info"
                            outlined
                        >
                            {{medicalObservationCount}} Medical Observations
                        </v-alert>
                    </v-col>
                    <v-col cols="12" md="6" class="text-center">
                        <v-alert
                            :value="true"
                            color="info"
                            icon="info"
                            outlined
                        >
                            {{deceasedSpecimenCount}} Deceased Specimens
                        </v-alert>
                    </v-col>
                </v-row>
            </v-container>
        </v-card>


        <v-card>
            <v-container v-if="loadingGraphs || loadGraphsError">
                <v-row v-if="loadingGraphs">
                    <v-col cols="12">
                        <v-progress-linear :indeterminate="true"></v-progress-linear>
                    </v-col>
                </v-row>

                <v-row v-else-if="loadGraphsError">
                    <v-col cols="12">
                        <v-alert outlined :value="true" color="error" icon="error">
                            {{loadGraphsError}}
                        </v-alert>
                    </v-col>
                </v-row>
            </v-container>
            <v-container v-else>
                <v-row >

                    <v-col cols="12" sm="6" offset-sm="3">
                        <v-container class="tables-container">
                            <v-row  class="graphs-container">
                                <v-col cols="12" class="graph-container text-center">
                                    <h2>Medical Observations</h2>
                                </v-col>
                                <v-col cols="12" class="graph-container">
                                    <OccurrenceObservationTable firstColumnHeader="Type" :data="rawData.medicalObservationsByType"></OccurrenceObservationTable>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-col>

                    <v-col cols="12" sm="6">
                        <v-container class="tables-container">
                            <v-row  class="graphs-container">
                                <v-col cols="12" class="graph-container text-center">
                                    <h2>Controlled Occurrences</h2>
                                </v-col>
                                <v-col cols="12" class="graph-container">
                                    <OccurrenceObservationTable firstColumnHeader="Site" :data="rawData.controlledOccurrencesBySite"></OccurrenceObservationTable>
                                </v-col>
                                <v-col cols="12" class="graph-container">
                                    <OccurrenceObservationTable firstColumnHeader="In The Course Of" :data="rawData.controlledOccurrencesByInTheCourseOf"></OccurrenceObservationTable>
                                </v-col>
                                <v-col cols="12" class="graph-container">
                                    <OccurrenceObservationTable firstColumnHeader="Details" :data="rawData.controlledOccurrencesByDetails"></OccurrenceObservationTable>
                                </v-col>
                                <v-col cols="12" class="graph-container">
                                    <OccurrenceObservationTable firstColumnHeader="Specimen Injury" :data="rawData.controlledOccurrencesBySpecimenInjury"></OccurrenceObservationTable>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-col>

                    <v-col cols="12" sm="6">
                        <v-container class="tables-container">
                            <v-row  class="graphs-container">
                                <v-col cols="12" class="graph-container text-center">
                                    <h2>Dangerous Occurrences</h2>
                                </v-col>
                                <v-col cols="12" class="graph-container">
                                    <OccurrenceObservationTable firstColumnHeader="Site" :data="rawData.dangerousOccurrencesBySite"></OccurrenceObservationTable>
                                </v-col>
                                <v-col cols="12" class="graph-container">
                                    <OccurrenceObservationTable firstColumnHeader="In The Course Of" :data="rawData.dangerousOccurrencesByInTheCourseOf"></OccurrenceObservationTable>
                                </v-col>
                                <v-col cols="12" class="graph-container">
                                    <OccurrenceObservationTable firstColumnHeader="Human Anatomical Location" :data="rawData.dangerousOccurrencesByHumanAnatomicalLocation"></OccurrenceObservationTable>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-col>

                    <!-- BELOW ARE THE OLD GRAPHS THAT WERE REMOVED -->

                    <!-- <v-flex xs12 lg6 offset-lg3>
                        <v-container>
                            <v-layout wrap class="graphs-container">
                                <v-flex xs12 class="graph-container text-xs-center">
                                    <h2>Medical Observations</h2>
                                </v-flex>
                                <v-flex xs12 md6 offset-md3 class="graph-container text-xs-center" v-if="medicalObservationsData.labels.length <= 0">
                                    <v-alert
                                        :value="true"
                                        color="info"
                                        icon="info"
                                        outlined
                                    >
                                        No Medical Observation data for the selected period
                                    </v-alert>
                                </v-flex>
                                <v-flex xs12 class="graph-container" v-if="medicalObservationsData.labels.length > 0">
                                    <DashboardBarGraph :height="graphHeight" :data="medicalObservationsData" :options="medicalObservationsGraphOptions" ref="refMedicalObservationsGraph"></DashboardBarGraph>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-flex>
                    
                    <v-flex xs12 lg6>
                        <v-container>
                            <v-layout wrap class="graphs-container">
                                <v-flex xs12 class="graph-container text-xs-center">
                                    <h2>Controlled Occurrences</h2>
                                </v-flex>
                            </v-layout>
                            <v-layout wrap class="graphs-container" v-if="controlledOccurrenceDataSite.labels.length <= 0">
                                <v-flex xs12 md6 offset-md3 class="graph-container text-xs-center">
                                    <v-alert
                                        :value="true"
                                        color="info"
                                        icon="info"
                                        outlined
                                    >
                                        No Controlled Occurrence data for the selected period
                                    </v-alert>
                                </v-flex>
                            </v-layout>
                            <v-layout wrap class="graphs-container" v-else v-show="false">
                                <v-flex xs12 sm6 offset-sm3 lg4 offset-lg4>
                                    <v-select
                                        :items="controlledOccurrenceOptions"
                                        item-text="text"
                                        item-value="value"
                                        v-model="selectedControlledOccurrenceOption"
                                        label="Controlled Occurrences by"
                                    ></v-select>
                                </v-flex>
                            </v-layout>
                            <v-layout wrap class="graphs-container" v-if="controlledOccurrenceDataSite.labels.length > 0 && (selectedControlledOccurrenceOption === 'Site' || selectedControlledOccurrenceOption === 'All' )">
                                <v-flex xs12 class="text-xs-center">
                                    by Site
                                </v-flex>
                                <v-flex xs12 class="graph-container">
                                    <DashboardBarGraph :height="graphHeight" :data="controlledOccurrenceDataSite" :options="controlledOccurrenceGraphOptions" ref="refControlledOccurrenceSiteGraph"></DashboardBarGraph>
                                </v-flex>
                            </v-layout>
                            <v-layout wrap class="graphs-container" v-if="controlledOccurrenceDataDetails.labels.length > 0 && (selectedControlledOccurrenceOption === 'Details' || selectedControlledOccurrenceOption === 'All' )">
                                <v-flex xs12 class="text-xs-center">
                                    by Details
                                </v-flex>
                                <v-flex xs12 class="graph-container">
                                    <DashboardBarGraph :height="graphHeight" :data="controlledOccurrenceDataDetails" :options="controlledOccurrenceGraphOptions" ref="refControlledOccurrenceDetailsGraph"></DashboardBarGraph>
                                </v-flex>
                            </v-layout>
                            <v-layout wrap class="graphs-container" v-if="controlledOccurrenceDataInTheCourseOf.labels.length > 0 && (selectedControlledOccurrenceOption === 'InTheCourseOf' || selectedControlledOccurrenceOption === 'All' )">
                                <v-flex xs12 class="text-xs-center">
                                    by In The Course Of
                                </v-flex>
                                <v-flex xs12 class="graph-container">
                                    <DashboardBarGraph :height="graphHeight" :data="controlledOccurrenceDataInTheCourseOf" :options="controlledOccurrenceGraphOptions" ref="refControlledOccurrenceInTheCourseOfGraph"></DashboardBarGraph>
                                </v-flex>
                            </v-layout>
                            <v-layout wrap class="graphs-container" v-if="controlledOccurrenceDataSpecimenInjury.labels.length > 0 && (selectedControlledOccurrenceOption === 'SpecimenInjury' || selectedControlledOccurrenceOption === 'All' )">
                                <v-flex xs12 class="text-xs-center">
                                    by Specimen Injury
                                </v-flex>
                                <v-flex xs12 class="graph-container">
                                    <DashboardBarGraph :height="graphHeight" :data="controlledOccurrenceDataSpecimenInjury" :options="controlledOccurrenceGraphOptions" ref="refControlledOccurrenceSpecimenInjuryGraph"></DashboardBarGraph>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-flex>

                    <v-flex xs12 lg6>
                        <v-container>
                            <v-layout wrap class="graphs-container">
                                <v-flex xs12 class="graph-container text-xs-center">
                                    <h2>Dangerous Occurrences</h2>
                                </v-flex>
                            </v-layout>
                            <v-layout wrap class="graphs-container" v-if="dangerousOccurrenceDataSite.labels.length <= 0">
                                <v-flex xs12 md6 offset-md3 class="graph-container text-xs-center">
                                    <v-alert
                                        :value="true"
                                        color="info"
                                        icon="info"
                                        outlined
                                    >
                                        No Dangerous Occurrence data for the selected period
                                    </v-alert>
                                </v-flex>
                            </v-layout>
                            <v-layout wrap class="graphs-container" v-else v-show="false">
                                <v-flex xs12 sm6 offset-sm3 lg4 offset-lg4>
                                    <v-select
                                        :items="dangerousOccurrenceOptions"
                                        item-text="text"
                                        item-value="value"
                                        v-model="selectedDangerousOccurrenceOption"
                                        label="Dangerous Occurrences by"
                                    ></v-select>
                                </v-flex>
                            </v-layout>
                            <v-layout wrap class="graphs-container" v-if="dangerousOccurrenceDataSite.labels.length > 0 && (selectedDangerousOccurrenceOption === 'Site' || selectedDangerousOccurrenceOption === 'All' )">
                                <v-flex xs12 class="text-xs-center">
                                    by Site
                                </v-flex>
                                <v-flex xs12 class="graph-container">
                                    <DashboardBarGraph :height="graphHeight" :data="dangerousOccurrenceDataSite" :options="dangerousOccurrenceGraphOptions" ref="refDangerousOccurrenceSiteGraph"></DashboardBarGraph>
                                </v-flex>
                            </v-layout>
                            <v-layout wrap class="graphs-container" v-if="dangerousOccurrenceDataInTheCourseOf.labels.length > 0 && (selectedDangerousOccurrenceOption === 'InTheCourseOf' || selectedDangerousOccurrenceOption === 'All' )">
                                <v-flex xs12 class="text-xs-center">
                                    by In The Course Of
                                </v-flex>
                                <v-flex xs12 class="graph-container">
                                    <DashboardBarGraph :height="graphHeight" :data="dangerousOccurrenceDataInTheCourseOf" :options="dangerousOccurrenceGraphOptions" ref="refDangerousOccurrenceInTheCourseOfGraph"></DashboardBarGraph>
                                </v-flex>
                            </v-layout>
                            <v-layout wrap class="graphs-container" v-if="dangerousOccurrenceDataHumanAnatomicalLocation.labels.length > 0 && (selectedDangerousOccurrenceOption === 'HumanAnatomicalLocation' || selectedDangerousOccurrenceOption === 'All' )">
                                <v-flex xs12 class="text-xs-center">
                                    by Human Anatomical Location
                                </v-flex>
                                <v-flex xs12 class="graph-container">
                                    <DashboardBarGraph :height="graphHeight" :data="dangerousOccurrenceDataHumanAnatomicalLocation" :options="dangerousOccurrenceGraphOptions" ref="refDangerousOccurrenceHumanAnatomicalLocationGraph"></DashboardBarGraph>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-flex> -->
                </v-row>
            </v-container>
        </v-card>

        <!-- OLD PRINTABLE GRAPHS SECTION BEFORE REPLACED WITH TABLES -->

        <!-- <v-card v-if="printing">
            <v-container>
                <v-layout wrap class="graphs-container">
                    <v-flex xs12 class="graph-container text-xs-center">
                        <h2>Medical Observations</h2>
                    </v-flex>
                    <v-flex xs12 md6 offset-md3 class="graph-container text-xs-center" v-if="medicalObservationsData.labels.length <= 0">
                        <v-alert
                            :value="true"
                            color="info"
                            icon="info"
                            outlined
                        >
                            No Medical Observation data for the selected period
                        </v-alert>
                    </v-flex>
                    <v-flex xs12 class="graph-container" v-else>
                        <PrintGraph :src="medicalObservationsImg"></PrintGraph>
                    </v-flex>
                </v-layout>
                
                <v-layout wrap class="graphs-container">
                    <v-flex xs12 class="graph-container text-xs-center">
                        <h2>Controlled Occurrences</h2>
                    </v-flex>
                </v-layout>
                <v-layout wrap class="graphs-container" v-if="controlledOccurrenceDataSite.labels.length <= 0">
                    <v-flex xs12 md6 offset-md3 class="graph-container text-xs-center">
                        <v-alert
                            :value="true"
                            color="info"
                            icon="info"
                            outlined
                        >
                            No Controlled Occurrence data for the selected period
                        </v-alert>
                    </v-flex>
                </v-layout>
                <v-layout wrap class="graphs-container" v-else>
                    <v-flex xs12 class="text-xs-center">
                        by Site
                    </v-flex>
                    <v-flex xs12 class="graph-container" v-if="controlledOccurrenceDataSite.labels.length > 0">
                        <PrintGraph :src="controlledOccurrenceDataSiteImg"></PrintGraph>
                    </v-flex>
                    <v-flex xs12 class="text-xs-center">
                        by Details
                    </v-flex>
                    <v-flex xs12 class="graph-container" v-if="controlledOccurrenceDataDetails.labels.length > 0">
                        <PrintGraph :src="controlledOccurrenceDataDetailsImg"></PrintGraph>
                    </v-flex>
                    <v-flex xs12 class="text-xs-center">
                        by In The Course Of
                    </v-flex>
                    <v-flex xs12 class="graph-container" v-if="controlledOccurrenceDataInTheCourseOf.labels.length > 0">
                        <PrintGraph :src="controlledOccurrenceDataInTheCourseOfImg"></PrintGraph>
                    </v-flex>
                    <v-flex xs12 class="text-xs-center">
                        by Specimen Injury
                    </v-flex>
                    <v-flex xs12 class="graph-container" v-if="controlledOccurrenceDataSpecimenInjury.labels.length > 0">
                        <PrintGraph :src="controlledOccurrenceDataSpecimenInjuryImg"></PrintGraph>
                    </v-flex>
                </v-layout>
                <v-layout wrap class="graphs-container">
                    <v-flex xs12 class="graph-container text-xs-center">
                        <h2>Dangerous Occurrences</h2>
                    </v-flex>
                </v-layout>
                <v-layout wrap class="graphs-container" v-if="dangerousOccurrenceDataSite.labels.length <= 0">
                    <v-flex xs12 md6 offset-md3 class="graph-container text-xs-center">
                        <v-alert
                            :value="true"
                            color="info"
                            icon="info"
                            outlined
                        >
                            No Dangerous Occurrence data for the selected period
                        </v-alert>
                    </v-flex>
                </v-layout>
                <v-layout wrap class="graphs-container" v-else>
                    <v-flex xs12 class="text-xs-center">
                        by Site
                    </v-flex>
                    <v-flex xs12 class="graph-container" v-if="dangerousOccurrenceDataSite.labels.length > 0">
                        <PrintGraph :src="dangerousOccurrenceDataSiteImg"></PrintGraph>
                    </v-flex>
                    <v-flex xs12 class="text-xs-center">
                        by In The Course Of
                    </v-flex>
                    <v-flex xs12 class="graph-container" v-if="dangerousOccurrenceDataInTheCourseOf.labels.length > 0">
                        <PrintGraph :src="dangerousOccurrenceDataInTheCourseOfImg"></PrintGraph>
                    </v-flex>
                    <v-flex xs12 class="text-xs-center">
                        by Human Anatomical Location
                    </v-flex>
                    <v-flex xs12 class="graph-container" v-if="dangerousOccurrenceDataHumanAnatomicalLocation.labels.length > 0">
                        <PrintGraph :src="dangerousOccurrenceDataHumanAnatomicalLocationImg"></PrintGraph>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-card> -->
    </div>
</template>

<script>
import * as auth from '@/services/auth';
import constants from 'comunet-btg-utah-repository-shared/constants';
import moment from 'moment'
import DashboardBarGraph from "@/components/dashboard/DashboardBarGraph"
import DashboardPieGraph from "@/components/dashboard/DashboardPieGraph"
import OccurrenceObservationTable from "@/components/dashboard/OccurrenceObservationTable";
import AvailableSpeciesBatchPoolsTable from "@/components/dashboard/AvailableSpeciesBatchPoolsTable";
import PrintGraph from "@/components/dashboard/PrintGraph"
import api from "@/services/api"

const commonGraphOptions = {
    // responsive: true,
    // maintainAspectRatio: false,
    scales: {
        yAxes: [
            {
                ticks: {
                    min: 0, // ensure that we always show down to 0 on the y axes
                    precision: 0 // don't show anything other than whole numbers on the y axes labels
                }
            }
        ],
        xAxes: [
            {
                ticks: {
                    // minRotation: 70,
                    autoSkip: false,
                    fontSize: 10
                }
            }
        ]
    },
    legend: {
        display: false // not much point in displaying legend when there is only one dataset
    }
};

export default {
    components: {
        DashboardBarGraph,
        DashboardPieGraph,
        PrintGraph,
        OccurrenceObservationTable,
        AvailableSpeciesBatchPoolsTable
    },
    props: [
        
    ],
    data() {
        return {
            auth: auth,
            constants: constants,

            printing: false,
            // graphImages: [],

            aliveSpecimensBySpeciesImg: null,
            aliveSpecimensByRoomImg: null,
            aliveSpecimensByGeographicalLocationImg: null,
            medicalObservationsImg: null,
            controlledOccurrenceDataSiteImg: null,
            controlledOccurrenceDataDetailsImg: null,
            controlledOccurrenceDataInTheCourseOfImg: null,
            controlledOccurrenceDataSpecimenInjuryImg: null,
            dangerousOccurrenceDataSiteImg: null,
            dangerousOccurrenceDataInTheCourseOfImg: null,
            dangerousOccurrenceDataHumanAnatomicalLocationImg: null,

            loadingGraphs: true,
            loadGraphsError: "",

            loadingCounts: true,
            loadCountsError: "",

            controlledOccurrenceCount: null,
            dangerousOccurrenceCount: null,
            medicalObservationCount: null,
            deceasedSpecimenCount: null,

            graphHeight: 150,

            /**
             * Just store the raw data in case we want to reference it later
             */
            rawData: null,

            /**
             * Medical Observations graph data
             */
            medicalObservationsData: {
                labels: [],
                datasets: [
                    {
                        label: "Medical Observations",
                        data: [],
                        backgroundColor: "#003865"
                    }
                ]
            },
            medicalObservationsGraphOptions: {},

            /**
             * Alive Specimens by Species graph data
             */
            aliveSpecimensBySpeciesData: {
                labels: [],
                datasets: [
                    {
                        label: "Specimens",
                        data: [],
                        backgroundColor: "#61B6AB"
                    }
                ]
            },
            aliveSpecimensBySpeciesGraphOptions: {},

            /**
             * Alive Specimens by Room graph data
             */
            aliveSpecimensByRoomData: {
                labels: [],
                datasets: [
                    {
                        label: "Rooms",
                        data: [],
                        backgroundColor: "#61B6AB"
                    }
                ]
            },
            aliveSpecimensByRoomGraphOptions: {},

            /**
             * Alive Specimens by Geographical graph data
             */
            aliveSpecimensByGeographicalLocationData: {
                labels: [],
                datasets: [
                    {
                        label: "Location",
                        data: [],
                        backgroundColor: ['#FF6633', '#FFB399', '#FF33FF', '#FFFF99', '#00B3E6', 
                            '#E6B333', '#3366E6', '#999966', '#99FF99', '#B34D4D',
                            '#80B300', '#809900', '#E6B3B3', '#6680B3', '#66991A', 
                            '#FF99E6', '#CCFF1A', '#FF1A66', '#E6331A', '#33FFCC',
                            '#66994D', '#B366CC', '#4D8000', '#B33300', '#CC80CC', 
                            '#66664D', '#991AFF', '#E666FF', '#4DB3FF', '#1AB399',
                            '#E666B3', '#33991A', '#CC9999', '#B3B31A', '#00E680', 
                            '#4D8066', '#809980', '#E6FF80', '#1AFF33', '#999933',
                            '#FF3380', '#CCCC00', '#66E64D', '#4D80CC', '#9900B3', 
                            '#E64D66', '#4DB380', '#FF4D4D', '#99E6E6', '#6666FF']
                    }
                ]
            },
            aliveSpecimensByGeographicalLocationGraphOptions: {},


            /**
             * Controlled Occurrences graphs data
             */
            controlledOccurrenceDataSite: {
                labels: [],
                datasets: [
                    {
                        label: "Controlled Occurrences",
                        data: [],
                        backgroundColor: "#F39F52"
                    }
                ]
            },
            controlledOccurrenceDataDetails: {
                labels: [],
                datasets: [
                    {
                        label: "Controlled Occurrences",
                        data: [],
                        backgroundColor: "#F39F52"
                    }
                ]
            },
            controlledOccurrenceDataInTheCourseOf: {
                labels: [],
                datasets: [
                    {
                        label: "Controlled Occurrences",
                        data: [],
                        backgroundColor: "#F39F52"
                    }
                ]
            },
            controlledOccurrenceDataSpecimenInjury: {
                labels: [],
                datasets: [
                    {
                        label: "Controlled Occurrences",
                        data: [],
                        backgroundColor: "#F39F52"
                    }
                ]
            },
            controlledOccurrenceGraphOptions: {},

            /**
             * Dangerous Occurrences graphs data
             */
            dangerousOccurrenceDataSite: {
                labels: [],
                datasets: [
                    {
                        label: "Dangerous Occurrences",
                        data: [],
                        backgroundColor: "#E50152"
                    }
                ]
            },
            dangerousOccurrenceDataInTheCourseOf: {
                labels: [],
                datasets: [
                    {
                        label: "Dangerous Occurrences",
                        data: [],
                        backgroundColor: "#E50152"
                    }
                ]
            },
            dangerousOccurrenceDataHumanAnatomicalLocation: {
                labels: [],
                datasets: [
                    {
                        label: "Dangerous Occurrences",
                        data: [],
                        backgroundColor: "#E50152"
                    }
                ]
            },
            dangerousOccurrenceGraphOptions: {},

            selectedControlledOccurrenceOption: "All",
            controlledOccurrenceOptions: [
                {
                    text: "All",
                    value: "All"
                },
                {
                    text: "Site",
                    value: "Site"
                },
                {
                    text: "In the course of",
                    value: "InTheCourseOf"
                },
                {
                    text: "Details",
                    value: "Details"
                },
                {
                    text: "Specimen Injury",
                    value: "SpecimenInjury"
                }
            ],

            selectedDangerousOccurrenceOption: "All",
            dangerousOccurrenceOptions: [
                {
                    text: "All",
                    value: "All"
                },
                {
                    text: "Site",
                    value: "Site"
                },
                {
                    text: "In the course of",
                    value: "InTheCourseOf"
                },
                {
                    text: "Human Anatomical Location",
                    value: "HumanAnatomicalLocation"
                }
            ],

            selectedRangeOption: "last7",
            rangeOptions: [
                {
                    text: "Last 7 Days",
                    value: "last7"
                },
                {
                    text: "Last 14 Days",
                    value: "last14"
                },
                {
                    text: "Last Month",
                    value: "lastMonth"
                },
                {
                    text: "Last Quarter",
                    value: "lastQuarter"
                },
                {
                    text: "Last Year",
                    value: "lastYear"
                },
                {
                    text: "Current Month to Date",
                    value: "currentMonth"
                },
                {
                    text: "Current Quarter to Date",
                    value: "currentQuarter"
                },
                {
                    text: "Current Year to Date",
                    value: "currentYear"
                }
            ]
        };
    },
    computed: {
        rangeDates() {
            let dates = {
                start: null,
                end: null
            };

            if (this.selectedRangeOption.startsWith("last")) {
                if (this.selectedRangeOption === "last7") {
                    dates.end = moment();
                    dates.start = dates.end.clone().add(-6, "days");
                }
                else if (this.selectedRangeOption === "last14") {
                    dates.end = moment();
                    dates.start = dates.end.clone().add(-13, "days");
                }
                else if (this.selectedRangeOption === "lastMonth") {
                    dates.end = moment().startOf("month").add(-1, "days");
                    dates.start = dates.end.clone().startOf("month");
                }
                else if (this.selectedRangeOption === "lastQuarter") {
                    dates.end = moment().startOf("quarter").add(-1, "days");
                    dates.start = dates.end.clone().startOf("quarter");
                }
                else if (this.selectedRangeOption === "lastYear") {
                    dates.end = moment().startOf("year").add(-1, "days");
                    dates.start = dates.end.clone().startOf("year");
                }
            }
            else if (this.selectedRangeOption.startsWith("current")) {
                dates.end = moment();

                if (this.selectedRangeOption === "currentMonth") {
                    dates.start = dates.end.clone().startOf("month");
                }
                else if (this.selectedRangeOption === "currentQuarter") {
                    dates.start = dates.end.clone().startOf("quarter");
                }
                else if (this.selectedRangeOption === "currentYear") {
                    dates.start = dates.end.clone().startOf("year");
                }
            }

            // adjust times to encompass entire days
            dates.start = dates.start.startOf("day");
            dates.end = dates.end.endOf("day");

            return dates;
        }
    },
    methods: {
        routeToDailyHusbandry() {
            this.$router.push({ name: "husbandry" });
        },
        routeToNewSpecimen() {
            this.$router.push({ name: "specimens", params: { openNewSpecimen: true } });
        },
        /**
         * This just helps really long labels not get cut off by the edge of the canvas that the
         * graph is rendered in.
         */
        truncateGraphLabel(val) {
            if (val.length <= 40) {
                return val;
            }

            return val.substring(0, 37) + "...";
        },
        parseMedicalObservationsData(data) {
            let newLabels = [];
            let newData = [];

            for (let i=0; i<data.length; i++) {
                let datum = data[i];

                newLabels.push(this.truncateGraphLabel(datum.Name));
                newData.push(datum.Total);
            }

            this.medicalObservationsData.labels = newLabels;
            this.medicalObservationsData.datasets[0].data = newData;
        },
        parseSpecimensBySpeciesData(data) {
            let newLabels = [];
            let newData = [];

            for (let i=0; i<data.length; i++) {
                let datum = data[i];

                newLabels.push(this.truncateGraphLabel(datum.SpeciesFullName));
                newData.push(datum.Total);
            }

            this.aliveSpecimensBySpeciesData.labels = newLabels;
            this.aliveSpecimensBySpeciesData.datasets[0].data = newData;
        },
        parseSpecimensByRoomData(data) {
            let newLabels = [];
            let newData = [];

            for (let i=0; i<data.length; i++) {
                let datum = data[i];

                newLabels.push(datum.RoomName);
                newData.push(datum.Total);
            }

            this.aliveSpecimensByRoomData.labels = newLabels;
            this.aliveSpecimensByRoomData.datasets[0].data = newData;
        },
        parseSpecimensByGeographicalLocationData(data) {
            let newLabels = [];
            let newData = [];

            for (let i=0; i<data.length; i++) {
                let datum = data[i];

                newLabels.push(datum.GeographicalLocationName);
                newData.push(datum.Total);
            }

            this.aliveSpecimensByGeographicalLocationData.labels = newLabels;
            this.aliveSpecimensByGeographicalLocationData.datasets[0].data = newData;
        },
        parseControlledOccurrenceData(data) {
            for (let j=0; j<this.controlledOccurrenceOptions.length; j++) {
                let option = this.controlledOccurrenceOptions[j].value;

                if (option === "All") {
                    continue;
                }

                let dataBySelectedOption = data[`controlledOccurrencesBy${option}`];

                this[`controlledOccurrenceData${option}`].labels.length = 0;
                this[`controlledOccurrenceData${option}`].datasets[0].data.length = 0;

                for (let i=0; i<dataBySelectedOption.length; i++) {
                    let datum = dataBySelectedOption[i];

                    this[`controlledOccurrenceData${option}`].labels.push(this.truncateGraphLabel(datum.Name));
                    this[`controlledOccurrenceData${option}`].datasets[0].data.push(datum.Total);
                }
            }
        },
        parseDangerousOccurrenceData(data) {
            for (let j=0; j<this.dangerousOccurrenceOptions.length; j++) {
                let option = this.dangerousOccurrenceOptions[j].value;

                if (option === "All") {
                    continue;
                }

                let dataBySelectedOption = data[`dangerousOccurrencesBy${option}`];

                this[`dangerousOccurrenceData${option}`].labels = [];
                this[`dangerousOccurrenceData${option}`].datasets[0].data = [];

                for (let i=0; i<dataBySelectedOption.length; i++) {
                    let datum = dataBySelectedOption[i];

                    this[`dangerousOccurrenceData${option}`].labels.push(this.truncateGraphLabel(datum.Name));
                    this[`dangerousOccurrenceData${option}`].datasets[0].data.push(datum.Total);
                }
            }
        },
        parseData(data) {
            this.controlledOccurrenceCount = data.controlledOccurrenceCountInDateRange;
            this.dangerousOccurrenceCount = data.dangerousOccurrenceCountInDateRange;
            this.medicalObservationCount = data.medicalObservationCountInDateRange;
            this.deceasedSpecimenCount = data.flaggedAsDeceasedInDateRange;
            this.parseSpecimensBySpeciesData(data.aliveActiveSpecimensBySpecies);
            this.parseSpecimensByRoomData(data.aliveSpecimensByRoom);
            this.parseSpecimensByGeographicalLocationData(data.aliveSpecimensByGeographicLocation);

            // old parse methods for graphs, before they were replaced by tables - BTG1-596
            // this.parseMedicalObservationsData(data.medicalObservationsByType);
            // this.parseControlledOccurrenceData(data);
            // this.parseDangerousOccurrenceData(data);

            
        },
        loadGraphs() {
            this.loadingGraphs = true;
            this.loadGraphsError = "";
            this.loadCountsError = "";

            this.fetchData();
        },
        fetchData() {
            let that = this;

            api.fetchDailyHusbandryDashboardData({
                params: {
                    startDate: this.rangeDates.start.toISOString(),
                    endDate: this.rangeDates.end.toISOString()
                },
                success: function(response) {
                    that.rawData = response.data;

                    that.parseData(that.rawData);
                },
                error: function(e) {
                    that.loadGraphsError = api.parseHttpRequestError(e);
                    that.loadCountsError = that.loadGraphsError;
                },
                finally: function() {
                    that.loadingGraphs = false;
                    that.loadingCounts = false;
                }
            });
        },
        loadData() {
            this.loadingCounts = true;
            this.loadCountsError = "";
            this.loadingGraphs = true;
            this.loadGraphsError = "";

            this.fetchData();
        },
        print() {
            if (this.printing) {
                this.printing = false;

                return;
            }

            if (this.$refs.refAliveSpecimensBySpeciesGraph) {
                this.aliveSpecimensBySpeciesImg = this.$refs.refAliveSpecimensBySpeciesGraph.getImage();
            }

            if (this.$refs.refAliveSpecimensByRoomGraph) {
                this.aliveSpecimensByRoomImg = this.$refs.refAliveSpecimensByRoomGraph.getImage();
            }

            if (this.$refs.refAliveSpecimensByGeographicalLocationGraph) {
                this.aliveSpecimensByGeographicalLocationImg = this.$refs.refAliveSpecimensByGeographicalLocationGraph.getImage();
            }

            if (this.$refs.refMedicalObservationsGraph) {
                this.medicalObservationsImg = this.$refs.refMedicalObservationsGraph.getImage();
            }

            if (this.$refs.refControlledOccurrenceSiteGraph) {
                this.controlledOccurrenceDataSiteImg = this.$refs.refControlledOccurrenceSiteGraph.getImage();
            }
            if (this.$refs.refControlledOccurrenceInTheCourseOfGraph) {
                this.controlledOccurrenceDataDetailsImg = this.$refs.refControlledOccurrenceInTheCourseOfGraph.getImage();
            }
            if (this.$refs.refControlledOccurrenceDetailsGraph) {
                this.controlledOccurrenceDataInTheCourseOfImg = this.$refs.refControlledOccurrenceDetailsGraph.getImage();
            }
            if (this.$refs.refControlledOccurrenceSpecimenInjuryGraph) {
                this.controlledOccurrenceDataSpecimenInjuryImg = this.$refs.refControlledOccurrenceSpecimenInjuryGraph.getImage();
            }

            if (this.$refs.refDangerousOccurrenceSiteGraph) {
                this.dangerousOccurrenceDataSiteImg = this.$refs.refDangerousOccurrenceSiteGraph.getImage();
            }
            if (this.$refs.refDangerousOccurrenceInTheCourseOfGraph) {
                this.dangerousOccurrenceDataInTheCourseOfImg = this.$refs.refDangerousOccurrenceInTheCourseOfGraph.getImage();
            }
            if (this.$refs.refDangerousOccurrenceHumanAnatomicalLocationGraph) {
                this.dangerousOccurrenceDataHumanAnatomicalLocationImg = this.$refs.refDangerousOccurrenceHumanAnatomicalLocationGraph.getImage();
            }

            this.printing = true;

            // this.$nextTick(() => {
            //     window.print();

            //     this.printing = false;
            // });

            /**
             * nextTick waits for the changes to the DOM to be finalized, but does not wait for the browser to actually
             * render those changes - which seems to have been causing nextTick to not work correctly. Instead, using
             * setTimeout does wait until the browser has actually completed its render, and then when we print it is
             * actually showing the graphs on the page.
             * 
             * Further explanation of the difference is here:
             * https://stackoverflow.com/questions/47634258/what-is-nexttick-or-what-does-it-do-in-vuejs
             */
            setTimeout(() => {
                window.print();

                this.printing = false;
            }, 0);
        }
    },
    created() {
        this.medicalObservationsGraphOptions = Object.assign({}, commonGraphOptions);
        this.aliveSpecimensBySpeciesGraphOptions = Object.assign({}, commonGraphOptions);
        this.aliveSpecimensByRoomGraphOptions = Object.assign({}, commonGraphOptions);
        this.controlledOccurrenceGraphOptions = Object.assign({}, commonGraphOptions);
        this.dangerousOccurrenceGraphOptions = Object.assign({}, commonGraphOptions);
    },
    mounted() {
        this.loadData();
    },
    watch: {
        selectedRangeOption: {
            handler() {
                // when selected option changes, load the graphs again
                this.loadGraphs();
            },
            deep: true
        }
    }
};
</script>

<style>
    .dates-label {
        font-weight: bold;
    }

    .print-button-container {
        padding-left: 5px;
        padding-right: 5px;
        padding-top: 0px;
        padding-bottom: 0px;
    }

    /* make sure there is a little bit of spacing between the tables */
    #app .tables-container .flex.graph-container {
        padding-bottom: 15px;
    }
</style>